<script setup>
import UspCard from './UspCard.vue'

const uspCards = [
  {
    icon: 'video',
    title: 'Recorded library',
    description: "Access to your tutor's growing library of recorded explanations and revision resources",
    color: 'blue'
  },
  {
    icon: 'message',
    title: 'Message your tutor',
    description: 'Message your tutor, ask questions, and get support between sessions',
    color: 'purple'
  },
  {
    icon: 'chart',
    title: 'Personal dashboard',
    description: 'A personal dashboard to manage your schedule and track progress',
    color: 'green'
  },
  {
    icon: 'calendar',
    title: 'Weekly structure',
    description: 'Weekly structure with flexibility built in to fit around your life',
    color: 'orange'
  }
]
</script>

<template>
  <section class="py-12 md:py-24 bg-gradient-to-br from-blue-50 to-purple-50">
    <div class="max-w-7xl mx-auto px-4 md:px-8">
      <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-16 items-center">
        <!-- Left Content -->
        <div class="lg:col-span-5">
          <h2 class="text-3xl md:text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            More than lessons — ongoing access
          </h2>
          <p class="text-base md:text-xl text-gray-600 mb-8 leading-relaxed">
            Bindle isn't pay-as-you-go tutoring. When you're signed up, you
            get continuous access to your tutor and learning tools that
            support progress beyond the live session.
          </p>
        </div>

        <!-- Right Content - USP Cards -->
        <div class="lg:col-span-7">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <UspCard
              v-for="(card, index) in uspCards"
              :key="index"
              v-bind="card"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
